export const styles = {
  container: {
    backgroundColor: '#fff !important',
    borderRadius: '.25rem !important',
    border: 'none !important',
    boxShadow: '0 .125rem .375rem 0 rgba(0,0,0,0.05) !important',
    margin: '0 !important',
    padding: '0 !important',
    width: '100% !important',
    height: '28rem !important',
  },
  containerLarge: {
    backgroundColor: '#fff !important',
    border: 'none !important',
    margin: '0 !important',
    padding: '0 !important',
    width: '100% !important',
    height: 'auto !important',
  },
  header: {
    display: 'flex',
    flexDirection: 'column',

    '& > div:last-child': {
      fontSize: '.900rem',
    },
  },
  subHeader: {
    fontSize: '1.15rem',
    fontWeight: 500,
  },
  radialChart: {
    padding: '0 !important',
    marginTop: '2rem',
    justifyContent: 'center !important',
  },
  centered: {
    textAlign: 'center !important',
    alignSelf: 'flex-end !important',
  },
  chartPlaceholder: {
    height: '25rem !important',
  },
  download: {
    background: '#fff',

    '& div:last-child': {
      flexDirection: 'column',
      alignItems: 'flex-start',

      '& > span': {
        padding: '0 !important',
        marginLeft: '.500rem',
      },
    },
  },
  icon: {
    color: '#9a9897 !important',
    fontSize: '.850rem !important',
    margin: '0 0 .500rem .250rem !important',
    cursor: 'pointer',
  },
};
